import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="container mx-auto py-20 px-4">
      <h1 className="text-4xl font-bold text-indigo-700 mb-6">Privacy Policy</h1>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        Your privacy is important to us at YourBrand. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">1. Information We Collect</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        We may collect personal information such as your name, email address, phone number, and home address when you submit it through our forms. We also collect non-personal information, such as your IP address and browsing activity, to improve our services.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">2. How We Use Your Information</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        The personal information we collect is used to provide you with a competitive offer for your home and to communicate with you about your submission. We may also use the information to improve our website and services.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">3. Information Sharing</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        We do not sell or share your personal information with third parties except as required by law or in connection with the services we provide. We may share your information with trusted partners who assist us in operating our website or conducting our business.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">4. Data Security</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        We take appropriate measures to ensure the security of your personal information. However, no data transmission over the internet can be guaranteed as completely secure. We cannot ensure or warrant the security of any information you transmit to us.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">5. Your Rights</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        You have the right to request access to, correction, or deletion of your personal information. If you would like to exercise any of these rights, please contact us at info@yourbrand.com.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">6. Changes to This Policy</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        We may update this Privacy Policy from time to time. Any changes will be posted on this page, and the revised version will be effective when posted.
      </p>

      <h2 className="text-2xl font-semibold text-indigo-700 mb-4">7. Contact Information</h2>
      <p className="text-lg text-gray-700 leading-relaxed mb-4">
        If you have any questions about this Privacy Policy, please contact us at info@yourbrand.com.
      </p>
    </div>
  );
}

export default PrivacyPolicy;

